import { ScratchCard, SCRATCH_TYPE } from 'scratchcard-js';
import { changeScreen } from './changeScreen';
import wpAjax from '../helpers/axios';
import { setPrizeWinLoseHtml } from './getPrize';
import sendAtreemoEmail from './sendAtreemoEmail';
import sendErrorEmail from './sendError';

/**
 * Scratchcard library: https://masth0.github.io/ScratchCard/
 */

const scratchCardConfig = {
	mobile: {
		sizes: [248, 360],
		coverImg:
			'/wp-content/themes/dm-cosmic/assets/images/scratchcard-mobile--transparent-2x2.png',
	},
	desktop: {
		sizes: [362, 515],
		coverImg:
			'/wp-content/themes/dm-cosmic/assets/images/scratchcard-desktop--transparent-2x2.png',
	},
};

async function initScratchcard(prize) {
	// console.log(prize);
	const deviceType = window.innerWidth >= 768 ? 'desktop' : 'mobile';
	const backgroundHtml = await getScratchcardBackgroundHtml(prize.prizeCode, deviceType);

	const sc = new ScratchCard('.js-scratchcard-container', {
		scratchType: SCRATCH_TYPE.LINE,
		containerWidth: scratchCardConfig[deviceType].sizes[0],
		containerHeight: scratchCardConfig[deviceType].sizes[1],
		brushSrc: '',
		imageForwardSrc: scratchCardConfig[deviceType].coverImg,
		imageBackgroundSrc: scratchCardConfig[deviceType].coverImg,
		htmlBackground: backgroundHtml,
		clearZoneRadius: 40,
		nPoints: 0,
		pointSize: 0,
		percentToFinish: 100,
		callback: () => {
			// console.log('remove annoying default behaviour for the callback');
		},
	});

	// Init
	let isComplete = false;
	const continueBtn = document.querySelector('.js-scratchcard-continue');
	sc.init().then(() => {
		document.querySelector('.js-scratchcard-container').classList.add('is-active');

		sc.canvas.addEventListener('scratch.move', () => {
			let percent = sc.getPercent().toFixed(0);
			// console.log(percent);
			if (percent > 80) {
				if (!isComplete) {
					isComplete = true;
					setTimeout(() => {
						completeScratchcard(prize.prizeCode);
					}, 1200);
				}
			} else if (percent > 70) {
				// Show button to progress
				continueBtn.innerHTML =
					prize.prizeCode === 'lose' ? 'Continue' : 'Claim your prize!';
				continueBtn.classList.remove('hidden');
			}
		});
	});

	continueBtn.addEventListener('click', (e) => {
		e.preventDefault();
		if (isComplete) return;

		isComplete = true;
		completeScratchcard(prize.prizeCode);
	});
}

// Move this to the server side
async function getScratchcardBackgroundHtml(prizeCode, deviceType) {
	const { data } = await wpAjax.post('', {
		action: 'ajax_get_scratchcard_background_html',
		prize: prizeCode,
		device: deviceType,
	});

	return data;
}

function completeScratchcard(prizeCode) {
	// Get the HTML for the prize win/lose screen
	setPrizeWinLoseHtml(prizeCode);

	// Change to the prize win/lose screen
	changeScreen('win_lose');

	// Send the atreemo email with the prize information to the user
	const firstName = localStorage.getItem('firstName'),
		email = localStorage.getItem('email'),
		ctcId = localStorage.getItem('ctcId');
	sendAtreemoEmail(prizeCode, firstName, ctcId, email);

	// Do win/lose actions in database
	markEmailAsPlayed(prizeCode);
	markPrizeAsWon(prizeCode);
}

function markEmailAsPlayed(prizeCode = false) {
	// console.log('marking as played...', prizeCode);
	if (prizeCode === false) return false;

	const email = localStorage.getItem('email');
	if (!email) return false;

	wpAjax
		.post('', {
			action: 'ajax_mark_email_as_played',
			prizeCode,
			email,
		})
		.then((data) => {
			console.log(data);
		})
		.catch((err) => {
			console.log(err);
			sendError(prizeCode, email);
		});
}

function markPrizeAsWon(prizeCode = false) {
	// console.log('marking as won...', prizeCode);
	if (prizeCode === false || prizeCode == 'lose') return false;

	const email = localStorage.getItem('email');
	if (!email) return false;

	wpAjax
		.post('', {
			action: 'ajax_mark_prize_as_won',
			email,
			prizeCode,
		})
		.then((data) => {
			console.log(data);
		})
		.catch((err) => {
			console.log(err);
		});
}

export { initScratchcard };
